import { useEffect, useState } from "react";

/**
 * @param {Array} items 
 * @returns {Object} 
 */


// export const useCheckboxClick = (items) => {
//   const [isParentSelected, setIsParentSelected] = useState(false);
//   const [selectedItems, setSelectedItems] = useState([]);

//   const handleParentCheckboxChange = () => {
//     const newParentState = !isParentSelected;
//     setIsParentSelected(newParentState);

//     if (newParentState) {
//       setSelectedItems(items.map((item) => item.id));
//     } else {
//       setSelectedItems([]);
//     }
//   };

//   const handleChildCheckboxChange = (itemId) => {
//     if (selectedItems.includes(itemId)) {
//       const newSelectedItems = selectedItems.filter((id) => id !== itemId);
//       setSelectedItems(newSelectedItems);
//       setIsParentSelected(false); 
//     } else {
//       const newSelectedItems = [...selectedItems, itemId];
//       setSelectedItems(newSelectedItems);

//       if (newSelectedItems.length === items.length) {
//         setIsParentSelected(true);
//       }
//     }
//   };

//   // New method to reset checkbox state
//   const resetCheckboxState = () => {
//     setSelectedItems([]);
//     setIsParentSelected(false);
//   };

//   return {
//     isParentSelected,
//     selectedItems,
//     handleParentCheckboxChange,
//     handleChildCheckboxChange,
//     resetCheckboxState, 
//   };
// };



export const useCheckboxClick = (items) => {
  const [selectedItems, setSelectedItems] = useState([]);

  // Automatically update isParentSelected based on selectedItems and items
  const isParentSelected = items.length > 0 && items.every(item => selectedItems.includes(item.id));

  const handleParentCheckboxChange = () => {
    if (isParentSelected) {
      // Unselect all visible items
      const visibleItemIds = items.map(item => item.id);
      setSelectedItems(prev => prev.filter(id => !visibleItemIds.includes(id)));
    } else {
      // Select all visible items
      const newIds = items.map(item => item.id);
      setSelectedItems(prev => Array.from(new Set([...prev, ...newIds])));
    }
  };

  const handleChildCheckboxChange = (itemId) => {
    setSelectedItems(prev => {
      if (prev.includes(itemId)) {
        return prev.filter(id => id !== itemId);
      } else {
        return [...prev, itemId];
      }
    });
  };

  const resetCheckboxState = () => {
    setSelectedItems([]);
  };

  return {
    isParentSelected,
    selectedItems,
    handleParentCheckboxChange,
    handleChildCheckboxChange,
    resetCheckboxState,
  };
};
